<template>

    <form class="mt-2" id="form-modal">
        
        
        <div class="col-md-12 px-0" >
            <div v-if="action != 'extend_due_date'">
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Title<span style="color: red">*</span>:</label>
                    <input type="text" v-model="task.title" class="form-control" placeholder="Title" />
                    
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Description<span style="color: red">*</span>:</label>
                    <div class="text_editor">
                    <tiny-mce-editor :vModelName.sync="task.description"></tiny-mce-editor><br />
                    </div>
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && role != 10" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date</label>            
                    <input type="date" v-model="task.due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div v-if="action != 'add_task_from_Support_ticket' && role != 10" class="form-group">
                <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer:</label>
                    <multiselect v-model="task.assigned_to_selected" :options="formData.developers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" 
                        :selectLabel="null" :searchable="true" label="full_name" track-by="id" style="font-size:12px !important">
                    </multiselect> 
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Task Type<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="task.task_type_selected" :options="taskTypesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Task Type">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Priority<span style="color: red">*</span>:</label>
                    <!-- <input type="text" class="form-control"  placeholder="Priority" /> -->
                     <multiselect v-model="task.priority_selected" :options="prioritiesList" :multiple="false" :selectedLabel="null" :deselectLabel="null" :allow-empty="false"
                     :selectLabel="null" :internal-search="true" label="name" track-by="value" placeholder="Priority">
                    </multiselect>
                </div>
                <div v-if="action != 'assign_to'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Customer</label>            
                    <multiselect :options="organizations" :allow-empty="true" :searchable="true" :multiple="true"
                        :selectedLabel="null" :deselectLabel="null"  :selectLabel="null" v-model="task.organizations_selected" label="name" track-by="organization_id"></multiselect>
                </div>
            </div>
            <div v-if="action == 'extend_due_date'">
                <div class="form-group">
                    <p>Due-Date is {{task.due_date |formatDate}}</p>
                </div>
                <div class="form-group">
                    <label  style="color: #48a6a6; font-weight: 600; font-size: 14px">Enter number  of days you want to extend due-date<span style="color: red">*</span>:</label>
                    <input class="form-control"  type="number" min="0" max="360" placeholder="Due Date" v-model="task.extend_due_date_days">
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Reason<span style="color: red">*</span>:</label>
                    <textarea type="text" v-model="task.extend_due_date_comment" class="form-control" placeholder="Reason" />                   
                </div>
            </div>
            <!-- <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'">
                <div v-if="action != 'moveToDevelopment' && action != 'extend_due_date'" class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Due Date<span style="color: red">*</span>:</label>            
                    <input type="date" v-model="due_date" class="form-control" placeholder="Due Date" />
                </div>
                <div class="form-group">
                    <label style="color: #48a6a6; font-weight: 600; font-size: 14px">Developer<span style="color: red">*</span>:</label>
                    <multiselect v-model="developer" :options="formData.developers" :selectedLabel="null" :deselectLabel="null" :allow-empty="false" :selectLabel="null" :searchable="true" 
                    label="full_name" track-by="id" style="font-size:12px !important">
                  </multiselect> 
                </div>
            </div> -->
            <!-- buttons -->
            <div class="text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">
                    Close
                </button>
                <button type="button" class="btn btn-default ml-1" @click="save">
                    <font-awesome-icon v-if="mini_loading" icon="spinner" style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;" />
                    {{action != 'edit' ? "Save" : "Update"}} 
                </button>
            </div>
            <table v-if="action == 'extend_due_date'" class="table table-bordered table-hover  mt-5 text-center">
                <th style="color:#48a6a6;" colspan="3"><b>Due Date History</b></th>
                <tbody>
                    <tr>
                    <th style="width: 35%;">Due Date</th>
                    <th style="width: 35%;">Updated By</th>
                    <th style="width: 30%;">Created At</th>
                    </tr>
                    <tr  v-if="loader" id="table_row" >
                        <td colspan="16">
                        <b-skeleton-wrapper >
                            <b-skeleton height="40px" ></b-skeleton>   
                            <b-skeleton height="40px"></b-skeleton>  
                            <b-skeleton height="40px"></b-skeleton>                                     
                        </b-skeleton-wrapper> 
                        </td>
                    </tr>
                    <tr v-else class="mt-2" v-for="dueDateRow in due_date_history" :key="dueDateRow.id">
                        <td  style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.due_date |formatDate }}</p> </td>
                        <td style="width: 35%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_by.first_name }} {{ dueDateRow.created_by.last_name }}</p> </td>
                        <td  style="width: 30%;"> <p style="white-space: break-spaces">{{ dueDateRow.created_at |formatCreatedAtDate}}</p> </td>
                    </tr>
                    <tr v-if="!loader && due_date_history.length < 1">
                        <td  colspan="3">
                            No Due-Date History Found.
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </form>
    
</template>

<script>
    import Multiselect from "vue-multiselect";
    import axios from 'axios';
    import moment from "moment";
    import TinymceEditor from "../../views/partials/tiny_mce_editor";
    Vue.filter("formatDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("DD MMM,Y");
        }
    });
    Vue.filter("formatCreatedAtDate", function (value) {
        if (value != "0000-00-00" && value != null) {
            return moment(String(value)).format("DD MMM,Y h:mm a");
        }
    });
    export default {
        components: {
            Multiselect,
            "tiny-mce-editor": TinymceEditor,
        },
        props:  ['formData','action', 'testData'],
        data: function(){
            return{
                task: {
                    id: null, 
                    title: '', 
                    description: '', 
                    due_date: '', 
                    status: 1, 
                    assigned_to_selected: {}, 
                    task_type_selected: {}, 
                    priority_selected: {}, 
                    organizations_selected: [],
                    support_ticket_id: '',
                    extend_due_date_days: '',
                    extend_due_date_comment: ''
                },
                loader:true,
                due_date_history: [],
                taskForm:{},
                organizations: [],
                org: '',
                org_search_value: "all",
                developers:[],
                mini_loading:false,
                role: JSON.parse(localStorage.getItem("role")),
            };
        },
        computed: {
            prioritiesList: function () {
                return this.$store.getters['tasks/prioritiesList'];
            },
            activityTypes: function () {
                return this.$store.getters['tasks/activityTypes'];
            },
            taskTypesList: function () {
                return this.$store.getters['tasks/taskTypesList'];
            },
        },
        watch:{
            // due_date_days: function () {
            //     this.due_date_days = parseInt(this.due_date_days);
            // },
            formData: function (){
                this.on_load_component();
            }
        },
        mounted: function(){
            this.on_load_component();
        },
        created: function () {
            this.get_organizations();
        },
        methods: {
            on_load_component () {
                if (this.action == 'edit') {
                    this.task = { ...this.formData.task };
                    // this.task.due_date = task.due_date != '' ? moment(new Date(task.due_date).toISOString()).format("Y-MM-DD") : ''
                    if(this.task.due_date){
                        this.task.due_date = new Date(this.task.due_date).toISOString().slice(0, 10);
                    }
                    this.task.assigned_to_selected = {full_name: this.task.assigned_to.name, id: this.task.assigned_to.id};
                    this.task.task_type_selected = this.taskTypesList.find(opt => opt.value == this.task.task_type);
                    this.task.priority_selected = this.prioritiesList.find(opt => opt.value == this.task.priority);
                    this.task.organizations_selected = this.task.organizations_obj;    
                } else if (this.action == 'add_task_from_Support_ticket') {
                    this.task.support_ticket_id = this.formData.ticket_id;
                    this.task.status = 0;
                    this.task.title = this.formData.ticket_title;
                    this.task.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                } else if (this.action == 'extend_due_date') {
                    this.task = { ...this.formData.task };
                    this.task.due_date = new Date(this.task.due_date).toISOString().slice(0, 10);
                    this.getDueDateHistory();
                } else if (this.action == 'assign_to') {
                    this.task = { ...this.formData.task };
                }
            },
            get_organizations(){
                axios.get("/admin/users/get-all-organizations?product=" + this.product).then((response) => {
                    this.organizations = response.data;
                    if(this.action == 'add_task_from_Support_ticket'){
                        this.task.organizations_selected = [this.organizations.find(opt => opt.name === this.formData.organization)];
                    }
                });
            },
            save(){
                this.mini_loading = true;
                let method = '';
                let is_form_valid = true;

                if(this.action == 'create' || this.action == 'edit'){
                    is_form_valid = this.validateCreateUpdateForm();
                    method = (this.action == 'create')? "add": "update";
                }else if(this.action == 'add_task_from_Support_ticket'){
                    method = "add";
                    this.validateAddTaskFromSupportTicketForm();
                }else if(this.action == 'extend_due_date'){
                    method = "extendDueDate";
                    this.validatEextendDueDateForm();
                }else if(this.action == 'assign_to'){
                    method = "assign";
                    this.validateAssignedToForm();
                }

                if (is_form_valid) {
                    this.$store.dispatch("tasks/"+method, [this.task]).then((response) => {
                        this.mini_loading = false;
                        console.log(response)
                        if(response && response.error){
                            this.serverValidationErrors(response.error);
                        }else{
                            this.skeletonLoader = true;
                            if(this.action != 'add_task_from_Support_ticket'){
                                let filtersData = [this.$store.getters['tasks/currentPage'], this.$store.getters['tasks/filters'], []]
                                this.$store.dispatch("tasks/getAll", filtersData).then(() => {
                                    window.$('#modal').modal('hide');
                                    this.$toast.success(response);
                                    this.skeletonLoader = false;
                                });
                            }
                        }
                    });
                } else {
                    this.mini_loading = false;
                }
            },
            validateCreateUpdateForm () {
                if(this.task.title == '' || this.task.description == '' || this.task.due_date=='' || this.task.assigned_to_selected.id == undefined 
                    || this.task.priority_selected.value == undefined || this.task.organizations_selected.length == 0 ){
                    if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }
                    // if (this.task.due_date == '') {
                    //     this.$toast.error('The due date field is required');
                    // }
                    // if(this.task.assigned_to_selected.id == undefined){
                    //     this.$toast.error('The developer field is required');
                    // }
                    if(this.task.task_type_selected.value == undefined){
                        this.$toast.error('The task type field is required');
                    }
                    if(this.task.priority_selected.value == undefined){
                        this.$toast.error('The priority field is required');
                    }
                    if(this.task.organizations_selected.length == 0){
                        this.$toast.error('The customers field is required');
                    }
                    return false;
                }else{
                    this.task.assigned_to = this.task.assigned_to_selected.id;
                    this.task.priority = this.task.priority_selected.value;
                    this.task.task_type = this.task.task_type_selected.value;
                    this.task.organizations = this.task.organizations_selected.map(({ organization_id }) => organization_id);
                    return true;
                }
            },
            validateAddTaskFromSupportTicketForm () {
                if(this.task.title == '' || this.task.description == '' || this.task.priority_selected.value == undefined){
                    if (this.task.title == '') {
                        this.$toast.error('The title field is required');
                    }
                    if (this.task.description == '' ) {
                        this.$toast.error('The description field is required');
                    }
                    if(this.task.task_type_selected.value == undefined){
                        this.$toast.error('The task type field is required');
                    }
                    if (this.task.priority_selected.value == undefined) {
                        this.$toast.error('The priority field is required');
                    }
                    return false;
                }else{
                    this.task.priority = this.task.priority_selected.value;
                    this.task.task_type = this.task.task_type_selected.value;
                    this.task.organizations = this.task.organizations_selected.map(({ organization_id }) => organization_id);
                    return true;
                }
            },
            validatEextendDueDateForm () {
                if (this.task.extend_due_date_days == 0 || this.task.extend_due_date_days == '' || this.task.extend_due_date_comment == '') {
                    if (this.task.extend_due_date_days == 0 || this.task.extend_due_date_days == '') {
                        this.$toast.error('Please enter the number of days you want to add in due-date.');
                    }
                    if (this.task.extend_due_date_comment == '') {
                        this.$toast.error('The reason field is required.');
                    }
                    return false;
                } else {
                    return true;
                }
            },
            getDueDateHistory () {
                this.loader = true;
                this.$store.dispatch("tasks/getActivity",[this.task.id, this.activityTypes.extendDueDate]).then((response) => {
                    this.due_date_history = response;
                    this.loader = false;
                });
            },
            getCurrentDueDate(){
                this.$store.dispatch("tasks/getCurrentDueDate",[this.taskForm]).then((response) => {
                    this.due_date_history = response.due_date;
                });
            },
            validateAssignedToForm(){
                if(this.task.due_date=='' || this.task.assigned_to_selected.id == undefined){
                    if(this.task.due_date == ''){
                        this.$toast.error('The due date field is required');
                    }
                    if(this.task.assigned_to_selected.id == undefined){
                        this.$toast.error('The developer field is required');
                    }
                    return false;
                }else{
                    this.task.assigned_to = this.task.assigned_to_selected.id;
                    this.task.status = 1;
                    return true;
                }
            },
            serverValidationErrors(error = []){
                if(error.hasOwnProperty('title')){
                     this.$toast.error('The title field is required');
                }
                if(error.hasOwnProperty('description')){
                     this.$toast.error('The description field is required');
                }
                if(error.hasOwnProperty('due_date')){
                     this.$toast.error('The due date field is required');
                }
                if(error.hasOwnProperty('assigned_to')){
                   this.$toast.error('The developer field is required');
                }
                if(error.hasOwnProperty('priority')){
                    this.$toast.error('The priority field is required');
                }
            },
        }
    }
</script>
<style scoped>
input[type="date"]{
  position: relative;
}
input[type="date"]::-webkit-calendar-picker-indicator {
    background-position: right;
    background-size: auto;
    cursor: pointer;
    position: absolute;
    bottom: 0;
    left: 0;
    top: 12px !important;
    right: 2%;
    width: auto;
}
.text-dark{
    color: rgb(72, 166, 166) !important;
}
</style>